import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../services/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading) return;
    setLoading(true);
    setMessage("");
    setError("");
    try {
      await api.post("/admins/forgot-password", { email });
      // Deliberately identical success text for existing and unknown emails.
      setMessage("Nếu email thuộc tài khoản quản trị, bạn sẽ nhận được liên kết đặt lại mật khẩu. Vui lòng kiểm tra hộp thư.");
    } catch (err) {
      const code = err.response?.data?.code || err.response?.data?.message;
      setError(code === "MAIL_NOT_CONFIGURED"
        ? "Máy chủ chưa cấu hình gửi email. Vui lòng liên hệ quản trị hệ thống."
        : code === "TOO_MANY_REQUESTS"
          ? "Bạn gửi quá nhiều yêu cầu. Vui lòng thử lại sau."
          : "Không thể gửi yêu cầu lúc này. Vui lòng thử lại.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-100 flex items-center justify-center min-h-screen px-4">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-2">Ji miso</h1>
        <h2 className="text-lg text-center text-gray-700 mb-4">Quên mật khẩu quản trị</h2>
        <p className="text-sm text-gray-600 mb-4">
          Nhập email quản trị để nhận liên kết đặt lại mật khẩu có hiệu lực 5 phút.
        </p>
        <form onSubmit={handleSubmit}>
          <label htmlFor="admin-reset-email" className="block text-gray-600 mb-1">Email</label>
          <input
            id="admin-reset-email"
            type="email"
            autoComplete="email"
            required
            maxLength={254}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {message && <p role="status" className="text-sm text-green-700 mt-3">{message}</p>}
          {error && <p role="alert" className="text-sm text-red-700 mt-3">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#34699A] text-white px-4 py-2 rounded-md mt-4 hover:bg-[#9EC6F3] disabled:opacity-50"
          >
            {loading ? "Đang gửi..." : "Gửi liên kết đặt lại mật khẩu"}
          </button>
        </form>
        <Link to="/login" className="block mt-4 text-sm text-blue-600 underline text-center">
          Quay lại đăng nhập
        </Link>
      </div>
    </div>
  );
}
